import { useTranslation } from 'react-i18next';
import { SvgPlayFilled } from '../../../../icons';
import { routes } from '../../../../routes/route-utils';
import { localizedRelativeTime } from '../../../../utils/ats-details-utils';
import { appendSequenceNumbers } from '../../utils';
import { CallToAction } from '../call-to-action-button';
import { isLimitedToHomeNetwork } from '../utils';
import { NotAvailableCallToAction } from './not-available-call-to-action';
import { ProgramCallToActionProps } from './program-call-to-action';
import { ProgramGetAccessCallToAction } from './program-get-access';

export function PresentProgramCallToAction({ source, focusedAsset: asset }: ProgramCallToActionProps) {
  const { t } = useTranslation();

  if (!source.isSubscribed) {
    return <ProgramGetAccessCallToAction source={source} />;
  }

  if (isLimitedToHomeNetwork(source)) {
    return <NotAvailableCallToAction source={source} />;
  }

  return (
    <CallToAction
      text={{
        primary: appendSequenceNumbers(t('details:watch-live'), asset),
        secondary: localizedRelativeTime(source.startTime, 'airtime'),
      }}
      image={{
        src: source.image,
        alt: source.name,
      }}
      icon={<SvgPlayFilled />}
      to={routes.live({ channelId: source.id })}
    />
  );
}
